const randomDigit = () => Math.floor(Math.random() * 10)

const calcCpfDigit = (digits, factorStart) => {
  let sum = 0
  let factor = factorStart
  digits.forEach((digit) => {
    sum += digit * factor
    factor -= 1
  })
  const rest = sum % 11
  return rest < 2 ? 0 : 11 - rest
}

export const generateCpf = () => {
  const base = Array.from({ length: 9 }, randomDigit)
  const d1 = calcCpfDigit(base, 10)
  const d2 = calcCpfDigit([...base, d1], 11)
  return [...base, d1, d2]
}

export const formatCpf = (digits) => {
  const s = digits.join('')
  return `${s.slice(0, 3)}.${s.slice(3, 6)}.${s.slice(6, 9)}-${s.slice(9, 11)}`
}

const CNPJ_WEIGHTS_12 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
const CNPJ_WEIGHTS_13 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

const calcCnpjDigit = (digits) => {
  const weights = digits.length === 12 ? CNPJ_WEIGHTS_12 : CNPJ_WEIGHTS_13
  const sum = digits.reduce((acc, digit, i) => acc + digit * weights[i], 0)
  const rest = sum % 11
  return rest < 2 ? 0 : 11 - rest
}

export const generateCnpj = () => {
  const base = Array.from({ length: 8 }, randomDigit)
  // "0001"  convenção pra unidade matriz, comum em CNPJs de exemplo.
  const branch = [0, 0, 0, 1]
  const digits = [...base, ...branch]
  const d1 = calcCnpjDigit(digits)
  const d2 = calcCnpjDigit([...digits, d1])
  return [...digits, d1, d2]
}

export const formatCnpj = (digits) => {
  const s = digits.join('')
  return `${s.slice(0, 2)}.${s.slice(2, 5)}.${s.slice(5, 8)}/${s.slice(8, 12)}-${s.slice(12, 14)}`
}
